import { ISbResult, StoryblokBridgeConfigV2, StoryblokBridgeV2 } from '@storyblok/react';
import { IPluginRefObject } from 'gatsby';

export interface WindowWithStoryblokBridge extends Window {
  StoryblokBridge: new (options?: StoryblokBridgeConfigV2) => StoryblokBridgeV2;
}

export interface CreateDatasourceEntry {
  name: string;
  value: string;
  dimension_value?: string;
}

export interface DatasourceEntry extends CreateDatasourceEntry {
  id: number;
  datasource_id: number;
  dimension_value: string;
}

export type CreateDatasourceProps = {
  name: string;
  slug: string;
};

export type Datasource = CreateDatasourceProps & {
  id: number;
  entries: Array<{ name: string; value: string; dimension_value?: string }>;
  dimensions: Array<{ name: string; entry_value: string }>;
  dimensions_attributes?: Array<{ name: string; entry_value: string }>;
};

export interface StoryblokDatasourceResult extends ISbResult {
  slug: string;
  params: Record<string, unknown>;
  page: number;
}

export interface StoryblokDimension {
  id: string;
  name: string;
  entry_value: string;
  datasource_id: number;
  created_at: string;
  updated_at: string;
}

export interface APIConnectorPluginSettings extends IPluginRefObject {
  resolve: string;
  options: {
    accessToken: string;
    typeName: string;
    fieldName: string;
    url: string;
    headers: {
      Token: string;
      Version: string;
    };
    resolveLinks?: 'url' | 'story';
    resolveRelations?: string;
  };
}

export const getUrlParams = (): Record<string, string | true> =>
  window.location.search
    .substr(1)
    .split('&')
    .filter((slug) => !!slug)
    .reduce(
      (accumulator, slug) => ({
        ...accumulator,
        ...(slug.split('=')[0] && {
          [slug.split('=')[0]]: slug.split('=')[1] || true,
        }),
      }),
      {},
    );
